import type { TNumberRange } from './number.types.ts';

const decimalFormat = /^-?\d+(\.\d+)?$/;

export const isValidDecimal = (
  text: string,
  { min, max }: TNumberRange = {},
): boolean => {
  if (!decimalFormat.test(text)) {
    return false;
  }

  const value = Number(text);

  return (
    (min === undefined || value >= min) && (max === undefined || value <= max)
  );
};
